import { render } from "./trader-slippage.vue?vue&type=template&id=4b3d03d8"
import script from "./trader-slippage.vue?vue&type=script&lang=js"
export * from "./trader-slippage.vue?vue&type=script&lang=js"

import "./trader-slippage.vue?vue&type=style&index=0&id=4b3d03d8&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__